let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("jixIn")).then(() => parcelRequire('b8C5r'));